module.exports = {
      id: "arrow-right-usage",
      viewBox: "0 0 9 14",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }